import { FormContextValues, useBoolean } from '@dreryk/react-common';
import { AddCircleIcon, Link, LinkSize } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { GroupSessionsNoteFieldFormBeanPart } from './GroupSessionsNoteField.types';
import { StyledTextarea } from './GroupSessionsNoteField.styled';

type GroupSessionsNoteFieldProps = Pick<FormContextValues<GroupSessionsNoteFieldFormBeanPart>, 'register'> & {
   readonly defaultValue: string | null | undefined;
};

export const GroupSessionsNoteField = (props: GroupSessionsNoteFieldProps): JSX.Element => {
   const [{ setTrue: showNoteTextarea }, noteTextareaShowed] = useBoolean(Boolean(props.defaultValue));

   if (noteTextareaShowed) {
      return (
         <StyledTextarea
            rows={4}
            maxRows={4}
            label={translationKeys.noteForGroup}
            placeholder={translationKeys.fillNote}
            controller={props.register('note')}
            defaultValue={null}
            maxLength={255}
            testId={'note'}
         />
      );
   }

   return (
      <Link
         onClick={showNoteTextarea}
         testId={'showNoteTextarea'}
         size={LinkSize.NORMAL}
         paddingTop
         icon={<AddCircleIcon />}
         label={translationKeys.addNoteForGroup}
      />
   );
};
